import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'mobx-react';
import {routerShape} from 'react-router';
import autobind from 'autobind-decorator';

import geolocation from 'spa/state/geolocation';

class Context extends React.Component {
  static propTypes = {
    router: routerShape.isRequired,
    store: PropTypes.object.isRequired,
    children: PropTypes.element,
  };

  static childContextTypes = {
    config: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
    createBookingLink: PropTypes.func.isRequired,
    i18n: PropTypes.object.isRequired,
    localStorageHelper: PropTypes.object.isRequired,
  };

  getChildContext() {
    return {
      config: this.props.store.config,
      content: this.props.store.content,
      createBookingLink: this.createBookingLink,
      i18n: this.props.store.i18n,
      localStorageHelper: this.props.store.localStorageHelper,
    };
  }

  @autobind createBookingLink(override) {
    const {router, store} = this.props;
    const {i18n, selection} = store;
    return router.createHref({
      pathname: `/${i18n.lc}/booking`,
      query: selection.getQuery(null, override),
    });
  }

  render() {
    const {store, children, router} = this.props;
    return (
      <Provider
        store={store}
        geolocation={geolocation}
        selection={store.selection}
        params={router.params}
      >
        {children}
      </Provider>
    );
  }
}

export default Context;



// WEBPACK FOOTER //
// ./spa/Components/Context/Context.jsx